/*
 * @Author: xuejian3721
 * @Date: 2023-11-27 12:07:58
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-08-14 14:38:56
 */
import api from '@/api/im-chat'
import { resCode } from '@/utils/res-types'

// 轮询消息定时器
let _pollMsgTimer = null
// 是否停止轮询
let _stopPollMsg = true
// 重连次数
let _reconnection = 0

export function loopMsgByPoll({ rootState, commit, dispatch }) {
  // 轮询消息
  api
    .batchReadMsg()
    .then(res => {
      if (res.code == resCode.success || res.code == resCode.dialogClosed) {
        _reconnection = 0
        !rootState.online && commit('setOnline', true, { root: true })

        res.data.forEach(msg => {
          dispatch('formatReceiveMsg', msg)
        })
        // dispatch("formatReceiveMsg", res.data);
      }
      !_stopPollMsg &&
        (_pollMsgTimer = setTimeout(() => {
          dispatch('loopMsgByPoll')
        }, 1000))
    })
    .catch(() => {
      console.log('reconnection', _reconnection)
      clearTimeout(_pollMsgTimer)
      _pollMsgTimer = setTimeout(() => {
        _reconnection++
        dispatch('loopMsgByPoll')
      }, 3000)
      // 尝试重连3次
      if (_reconnection > 2) {
        rootState.online && commit('setOnline', false, { root: true })
      }
    })
}

export function startLoopMsgByPoll({ dispatch }) {
  if (_stopPollMsg) {
    _stopPollMsg = false
    dispatch('loopMsgByPoll')
  }
}

export function stopLoopMsgByPoll() {
  _stopPollMsg = true
  clearTimeout(_pollMsgTimer)
}

export async function sendMsgByPoll({ commit, dispatch, state }, content) {
  const { dialogType, isJoinKefu, pageExpired } = state.chatInfo
  try {
    if (state.isAiMsgOpen) { // AI消息开关
      if (dialogType === 0 && !isJoinKefu && !pageExpired) { // 非人工服务，走AI
        dispatch('sendAiMessage', content)
      } else { // 加入人工服务
        const res = await api.sendMsg(content)
        if (res.code == resCode.success) {
          dispatch('formatReceiveMsg', res.data)
        }
      }
    } else {
      const res = await api.sendMsg(content)
      if (res.code == resCode.success) {
        dispatch('formatReceiveMsg', res.data)
      }
    }
  } catch (error) {
    commit('setIsSending', false)
    console.log(error)
    return false
  }
  commit('setIsSending', false)
  return true
}
